import React, { Fragment } from "react";
import { Grid, Typography } from "@material-ui/core";
import map from "lodash/map";
import startCase from "lodash/startCase";

const BreakdownTable = ({ breakdown }) => {
  return (
    <Grid container spacing={4}>
      {map(breakdown.toJS(), (choices, section) => {
        return (
          <Fragment key={`breakdown-dialog-${section}`}>
            <Grid item xs={12}>
              <Typography variant="h6">{startCase(section)}</Typography>
            </Grid>
            <Grid item xs={12}>
              {map(choices, (choice) => {
                return (
                  <Typography key={`choice-${section}-${choice.title}`}>
                    {choice.title}
                  </Typography>
                );
              })}
            </Grid>
          </Fragment>
        );
      })}
    </Grid>
  );
};

export default BreakdownTable;
